import makeVueModal from '@/views/modal/make_vue_modal';
import track from '@/helpers/track';

let contactsModal = null;
let localeSwitcherModal = null;

$(document).on('turbolinks:before-cache', () => {
  if (contactsModal) {
    contactsModal.destroy();
    contactsModal = null;
  }

  if (localeSwitcherModal) {
    localeSwitcherModal.destroy();
    localeSwitcherModal = null;
  }
});

$(document).on('turbolinks:load', async () => {
  if (!document.body.className.includes('v4')) { return; }

  $('footer.b-footer.v4 button.lead').one('click', async ({ currentTarget }) => {
    const $node = $(currentTarget);

    contactsModal ||= makeVueModal({
      trigger: currentTarget,
      vue: {
        importComponent: async () => await import('@/vue/modals/call_lead'),
        props: {
          submitUrl: $node.data('submit_url'),
          leadType: $node.data('leadType'),
          trackEvent: $node.data('trackEvent'),
          trackEventLocation: $node.data('trackEventLocation'),
          privacyUrl: $node.data('privacy_url'),
          faqUrl: $node.data('faq_url'),
          graphqlUrl: $node.data('graphql_url')
        }
      },
      isCloseOnSubmit: true,
      onShow: () => {
        const { trackEventLocation } = $(currentTarget).data();
        track({ event: 'callback_form_opened', form_location: trackEventLocation });
      }
    });
    contactsModal.show();
  });

  $('footer.b-footer.v4 .locale_switcher-modal-trigger').one('click', async ({ currentTarget }) => {
    localeSwitcherModal ||= makeVueModal({
      trigger: currentTarget,
      vue: {
        importComponent: async () => await import('@/vue/modals/locale_switcher')
      }
    });
    localeSwitcherModal.show();
  });
});
